import React, { useState } from "react";
import Office from "../parts/Office";
import Bedroom from "../parts/Bedroom";
import Chicke from "../parts/Chicke";

// Style \\
import "../../assets/styles/sections/productsPart.scss";
import "../../assets/styles/parts/roomType.scss";

const ProductsPart = () => {
  const [openOfice, setOpenOfice] = useState(true);
  const [openBedroom, setOpenBedroom] = useState(false);
  const [openChicken, setOpenChicken] = useState(false);

  const newProduct = () => {
    console.log("i am working new");
    setOpenOfice(true);
    setOpenBedroom(false);
    setOpenChicken(false);
  };
  const popular = () => {
    console.log("i am working Popular");

    setOpenOfice(false);
    setOpenBedroom(true);
    setOpenChicken(false);
  };
  const edit = () => {
    setOpenOfice(false);
    setOpenBedroom(false);
    setOpenChicken(true);
  };

  return (
    <section className="products">
      <div className="containers">
        <div className="products_items mt-14">
          <div className="products_items_productsSortButton flex gap-12">
            <button
              onClick={newProduct}
              className={` px-3 py-2 ${openOfice ? "activeProducts" : ""}`}
            >
              Office
            </button>
            <button
              onClick={popular}
              className={` px-3 py-2 ${openBedroom ? "activeProducts" : ""}`}
            >
              Bedroom
            </button>
            <button
              onClick={edit}
              className={` px-3 py-2 ${openChicken ? "activeProducts" : ""}`}
            >
              Chicken
            </button>
          </div>
          <div className="hrLine mt-3"></div>

          <div className="cards_box mt-8">
            {openOfice && <Office />}
            {openBedroom && <Bedroom />}
            {openChicken && <Chicke />}
          </div>

          <div className="hrLine mt-3"></div>
        </div>
      </div>
    </section>
  );
};

export default ProductsPart;
